import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Carousel.css';

function Carousel() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [
    '/images/carousel/eiffel1.webp', // Tour Eiffel
    '/images/carousel/eiffel2.webp', // Tour Eiffel
    '/images/carousel/slide1.webp', // Notre-Dame
    '/images/carousel/slide2.webp', // Sacré-Cœur
    '/images/welcome/opera-garnier.webp', // Opéra Garnier
    '/images/carousel/slide4.webp', // Pyramide du Louvre
  ];

  // Auto-play: change de slide toutes les 5 secondes
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="carousel">
      {/* Slides */}
      <div className="carousel-slides">
        {images.map((image, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          >
            {/* Overlay pour améliorer la lisibilité du texte */}
            <div className="carousel-overlay"></div>

            {/* Contenu sur l'image */}
            <div className="carousel-content">
              {/* Logo CISAC */}
              <div className="carousel-logo">
                <img src="/images/logo/cisac-logo-gold-web.png" alt="CISAC 100 Years Logo" />
              </div>

              {/* Titre */}
              <h1 className="carousel-year">CISAC 2026</h1>
              <h2 className="carousel-event">General Assembly</h2>
              <p className="carousel-anniversary">Celebrating 100 Years</p>

              {/* Détails sans emojis */}
              <div className="carousel-info">
                <p className="carousel-date">June 4, 2026</p>
                <p className="carousel-location">Paris, France</p>
              </div>

              {/* Bouton Registration */}
              <Link to="/registration" className="carousel-btn">
                Registration
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Carousel;
